/** Shared layout classes for the right-side detail drawers (prompt/execution/brand-sources).
 * In RTL, inline-start is the visual right, so justify-content-start docks the panel there.
 */
export const rightDrawerOverlayClass = 'position-fixed top-0 start-0 end-0 bottom-0 d-flex justify-content-start';

export const rightDrawerAsideClass =
  'position-relative bg-white dark__bg-card-dark shadow-lg d-flex flex-column h-100 w-100';

export const rightDrawerZIndex = 1050;
